import { urlApiEstimateSetting } from '~/utils/constants/apis';
import axiosClient from './axiosClient';
import { IApiBaseResponse } from '~/utils/interface/common';
import {
  IPayloadCreateDetailsTemplate,
  IPayloadCreateIntroductionTemplate,
  IResponseGetEstimateLayouts,
  IResponseGetEstimateTemplateAuthorization,
  IResponseGetEstimateTemplateIntroduction,
  IResponseGetEstimateTemplates,
  SigningUpgradesFormData
} from '~/utils/interface/estimateSetting';

const estimateSettingApi = {
  getEstimateLayouts() {
    return axiosClient.get<IApiBaseResponse<IResponseGetEstimateLayouts>>(`${urlApiEstimateSetting.getEstimateLayout}`);
  },

  createEstimateLayout(data: FormData | Record<string, unknown>) {
    const formData = data instanceof FormData
      ? data
      : (() => {
        const fd = new FormData();
        Object.keys(data).forEach((key) => {
          const value = data[key];
          if (value !== undefined && value !== null) {
            fd.append(key, value instanceof File ? value : String(value));
          }
        });
        return fd;
      })();
    return axiosClient.post<IApiBaseResponse<any>>(
      `${urlApiEstimateSetting.createEstimateLayout}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },

  getEstimateTemplates() {
    return axiosClient.get<IApiBaseResponse<IResponseGetEstimateTemplates>>(`${urlApiEstimateSetting.getEstimateTemplate}`);
  },

  createIntroductionTemplate(data: IPayloadCreateIntroductionTemplate) {
    return axiosClient.post<IApiBaseResponse<any>>(`${urlApiEstimateSetting.createIntroductionTemplate}`, data);
  },

  createDetailsTemplate(data: IPayloadCreateDetailsTemplate) {
    return axiosClient.post<IApiBaseResponse<any>>(`${urlApiEstimateSetting.createDetailsTemplate}`, data);
  },

  signingUpgrades(data: SigningUpgradesFormData) {
    return axiosClient.post<IApiBaseResponse<any>>(`${urlApiEstimateSetting.signingUpgrades}`, data);
  },
  getEstimateTemplateIntroduction() {
    return axiosClient.get<IApiBaseResponse<IResponseGetEstimateTemplateIntroduction>>(`${urlApiEstimateSetting.getEstimateTemplateIntroduction}`);
  },

  getEstimateTemplateAuthorization() {
    return axiosClient.get<IApiBaseResponse<IResponseGetEstimateTemplateAuthorization>>(`${urlApiEstimateSetting.getEstimateTemplateAuthorization}`);
  },

};

export default estimateSettingApi;
